import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Rooms from "./components/Rooms";
import Cafe from "./components/Cafe";
import Contact from "./components/Contact";
import EventHall from "./components/EventHall";
import AdminPanel from "./components/admin/AdminPanel";
import BookingForm from "./components/BookingForm";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Main Home Page */}
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <Hero />       {/* Hero section with Book Now button */}
                <About />
                <Rooms />
                <Cafe />
                <EventHall />
                <Contact />
              </>
            }
          />

          {/* Booking Page */}
          <Route path="/booking" element={<BookingForm />} />

          {/* Admin Panel */}
          <Route path="/admin-ferej-secret" element={<AdminPanel />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
